import React, { Component } from 'react';
import Modal from 'react-modal';
import { connectModal } from 'redux-modal';
import { PLAYER_ERROR_DIALOG } from '../../../constants';
import translate from '../../TranslateHOC';

class PlayerErrorDialog extends Component {
  constructor() {
    super();
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    this.props.handleHide();
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  }

  render() {
    const { show, strings, code, message } = this.props;
    const trans = strings;

    return (
      <Modal
        isOpen={show}
        overlayClassName="dialog__overlay"
        className="dialog__content"
        onRequestClose={this.handleCancel}
        role="dialog"
        ariaHideApp={true}
        contentLabel={trans.playerErrorDetected}
      >
        <div className="dialog--ad-block">
          <div className="dialog__title">
            {trans.playerErrorDetected}: {code}
          </div>
          <div className="dialog__message">
            <p>{message}</p>
          </div>
          <div className="dialog__action-row">
            <button
              className="button-link dialog__btn dialog__btn--close-link"
              onClick={this.handleCancel}
            >
              {strings.playAnyway}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default translate(
  connectModal({ name: PLAYER_ERROR_DIALOG })(PlayerErrorDialog)
);
